export default __webpack_public_path__ + "static/media/IBMDownload.ec7768fe.svg";